import * as Yup from 'yup'

const schemaDepartment = Yup.object().shape({
	department_name: Yup.string().required('Nama Departement harus di isi'),
})

export default schemaDepartment
